/* eslint-disable no-unused-vars */
import moment from 'moment';

import {
  USERS_ENTITY,
  ORDER_USER,
  SUBCATEGORIES_ENTITY,
  CATEGORIES_ENTITY,
  DEFECT_TYPES_ENTITY,
  ORDER_LIST_ENTITY,
  COMPLAINTS_ENTITY,
  MANAGER_TECHNICIAN_ENTITY,
  ASSETS_ENTITY,
  LOCATIONS_ENTITY,
  CONTACT_INFO,
  APPLICATION_FORM_QUESTIONS,
  APPLICATION_FORM_PACKAGE_PLANS,
  APPLICATION_FORM_SERVICES,
  APPLICATION_FORM_PACKAGES,
  SERVICE_PROCESS_STEPS,
  SERVICE_PROCESS_DETAILS,
  SERVICE_PROCESS_SUBTITLE,
  FORMS,
  PHOTO_ORDER_APPLICATION,
  STEPS_QUESTIONS,
  PROCESSED_PHOTO_ENTITY,
  COUPONS_MANAGEMENT,
  CONDITIONS_PAGE,
  SERVICE_BASED_FAQ,
  SERVICE_PAGE_FAQ,
  PHOTO_STORE_PLAN,
  TIME_LINE_HEADING,
  TIME_LINE_BODY,
  SERVICE_TIMELINE,
  PACKAGE_TIMELINE,
  PACKAGE_PROCESS_STEPS,
  PACKAGE_PROCESS,
  REFFERAL_DETAILS,
  ADVANTAGE_PAGE_ENTITY,
  REVIEWS_PAGE_ENTITY,
  HOW_IT_WORKS_PAGE_ENTITY,
  PHOTOMITRA_ADVANTAGE_PAGE_ENTITY,
  PHOTOMITRA_HOW_IT_WORKS_PAGE_ENTITY,
  PHOTOMITRA_TAKING_PHOTO_STEPS_PAGE_ENTITY,
  ABOUT_PAGE_OUR_TEAM,
  RELATED_ARTICLE,
  DOCUMITRA_PARTNERS,
  HOMEPAGE_ARTICLE,
  NEWS_ARTICLE_ENTITY,
  BUCKET_MANAGEMENT,
  BANNER_MANAGEMENT,
  SERVICE_CARDS_MANAGEMENT,
} from '../constants/EntityName';
import { BASE_IMAGE_URL } from '../env';

export const positionSort = (
  firstEntity: { position: number },
  secondEntity: { position: number }
) => firstEntity.position - secondEntity.position;

const imageKeyList = ['activeIcon', 'iconImage', 'inactiveIcon', 'serviceImage'];

const getAssetUrl = (value?: string) => {
  if (!value || value.startsWith('http') || value.startsWith('blob:')) {
    return value;
  }

  if (!BASE_IMAGE_URL) {
    return value;
  }

  return `${BASE_IMAGE_URL}${value.startsWith('/') ? value : `/${value}`}`;
};

export const getIncomingPayload = (entityName: string, apiData: any) => {
  let countryCode = '';
  let phoneNumber = '';
  function splitPhoneNumber(phoneNumber: any) {
    const lastIndex = phoneNumber.lastIndexOf('-');

    if (lastIndex !== -1) {
      const countryCode = phoneNumber.substring(0, lastIndex);
      const remainingDigits = phoneNumber.substring(lastIndex + 1);

      return [countryCode, remainingDigits];
    } else {
      return null;
    }
  }

  if (entityName === USERS_ENTITY) {
    const splitCode = splitPhoneNumber(apiData?.phone);
    countryCode = splitCode && splitCode[0];
    phoneNumber = splitCode && splitCode[1];
  }

  switch (entityName) {
    case USERS_ENTITY: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'phone') {
          return { ...acc, [key]: phoneNumber };
        }

        if (key === 'createdAt') {
          return { ...acc, [key]: countryCode };
        }

        if (key === 'password') {
          return { ...acc, [key]: '*****' };
        }

        if (key === 'isActive') {
          const normalized =
            value === 'Active' ||
              value === true ||
              value === 'true' ||
              value === 'True' ||
              value === undefined ||
              value === null
              ? 'Active'
              : 'Inactive';
          return { ...acc, [key]: normalized };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case ORDER_USER: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'active') {
          const normalized =
            value === 'Active' ||
              value === true ||
              value === 'true' ||
              value === 'True' ||
              value === undefined ||
              value === null
              ? 'Active'
              : 'Inactive';
          return { ...acc, [key]: normalized };
        }
        if (key === 'isVerified') {
          const normalized =
            value === 'Verified' ||
              value === true ||
              value === 'true' ||
              value === 'True' ||
              value === undefined ||
              value === null
              ? 'Verified'
              : 'Unverified';
          return { ...acc, [key]: normalized };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case SERVICE_CARDS_MANAGEMENT: {
      return {
        ...apiData,
        heading: apiData?.category?.id || apiData?.categoryId,
        image: getAssetUrl(apiData?.image),
      };
    }

    case APPLICATION_FORM_QUESTIONS: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'service') {
          return { ...acc, [key]: value?.id };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case DEFECT_TYPES_ENTITY: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'subcategory') {
          return { ...acc, [key]: value.id };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case ADVANTAGE_PAGE_ENTITY:
    case REVIEWS_PAGE_ENTITY:
    case HOW_IT_WORKS_PAGE_ENTITY:
    case PHOTOMITRA_ADVANTAGE_PAGE_ENTITY:
    case PHOTOMITRA_HOW_IT_WORKS_PAGE_ENTITY:
    case PHOTOMITRA_TAKING_PHOTO_STEPS_PAGE_ENTITY: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'iconImage') {
          return {
            ...acc,
            [key]: value?.startsWith('https') || !value ? value : `${BASE_IMAGE_URL}/${value}`,
          };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case APPLICATION_FORM_SERVICES: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (imageKeyList.includes(key)) {
          return {
            ...acc,
            [key]: value?.startsWith('https') || !value ? value : `${BASE_IMAGE_URL}/${value}`,
          };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case ABOUT_PAGE_OUR_TEAM:
    case RELATED_ARTICLE: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'url') {
          return {
            ...acc,
            [key]: value?.startsWith('https') || !value ? value : `${BASE_IMAGE_URL}/${value}`,
          };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case HOMEPAGE_ARTICLE: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'url') {
          return {
            ...acc,
            [key]: value?.startsWith('https') || !value ? value : `${BASE_IMAGE_URL}/${value}`,
          };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case NEWS_ARTICLE_ENTITY: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'imageUrl') {
          return {
            ...acc,
            [key]: value?.startsWith('http') || value?.startsWith('/') || !value ? value : `${BASE_IMAGE_URL}/${value}`,
          };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case BANNER_MANAGEMENT: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'bannerImage') {
          return {
            ...acc,
            [key]: value?.startsWith('https') || !value ? value : `${BASE_IMAGE_URL}/${value}`,
          };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case LOCATIONS_ENTITY:
    case ASSETS_ENTITY: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'locationType') {
          return { ...acc, [key]: value.id };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case CATEGORIES_ENTITY: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'asset') {
          return { ...acc, [key]: value?.id };
        }
        if (key === 'manager') {
          return { ...acc, [key]: value?.id };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case SUBCATEGORIES_ENTITY: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'category') {
          return { ...acc, [key]: value?.id };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case COMPLAINTS_ENTITY: {
      return Object.entries(apiData).reduce((acc, [key, value]: any) => {
        if (key === 'defectType') {
          return { ...acc, [key]: value?.id };
        }

        return { ...acc, [key]: value };
      }, {});
    }

    case APPLICATION_FORM_PACKAGES: {
      return {
        ...apiData,
        service: apiData?.service?.id,
        plans: apiData?.plans?.map((plans: { id: string }) => plans.id),
        serviceAttributes: apiData?.serviceAttributes?.map(
          (serviceAttributes: { id: string }) => serviceAttributes.id
        ),
        planInfo: apiData?.planInfo,
        packageInfo: apiData?.packageInfo,
        documitraFees: apiData?.documitraFees,
        governmentFees: apiData?.governmentFees,
        slug: apiData?.slug,
      };
    }

    case STEPS_QUESTIONS: {
      return {
        ...apiData,
        question: `${apiData?.question?.id}`,
      };
    }

    case APPLICATION_FORM_PACKAGE_PLANS: {
      return {
        ...apiData,
        service: apiData?.service?.id,
        features: apiData?.features?.map((feature: { id: string }) => feature.id),
        documents: apiData?.documents?.map((document: { id: string }) => document.id),
        price: apiData?.price ? Number(apiData.price) : undefined,
      };
    }

    case PHOTO_STORE_PLAN: {
      return {
        title: apiData.title,
        pricePerMember: apiData?.pricePerMember ? Number(apiData.pricePerMember) : undefined,
        discountedPricePerMember: apiData?.discountedPricePerMember
          ? Number(apiData.discountedPricePerMember)
          : undefined,
      };
    }

    case FORMS: {
      const updatedApiData = {
        formName: apiData?.formName,
        steps: apiData?.steps?.map((step: any) => ({
          sequence: step?.sequence,
          id: step?.id,
          stepTitle: step?.stepTitle,
          stepTime: step?.stepTime,
          stepQuestions: step?.stepQuestions?.map((stepQuestion: { id: string }) => stepQuestion),
          // stepQuestions: step?.stepQuestions?.map(({ id, questionText, ...rest }: any) => ({
          //     ...rest,
          //     value: id,
          //     id: id,
          //     label: questionText,
          //     questionText: questionText,
          // })),
        })),
      };
      return {
        ...updatedApiData,
        package: apiData?.package?.id,
      };
    }

    case PACKAGE_PROCESS_STEPS: {
      return {
        ...apiData,
        packages: apiData?.package?.name,
      };
    }

    case PACKAGE_TIMELINE: {
      return {
        ...apiData,
        table: JSON.parse(apiData?.table),
        packages: apiData?.package?.name,
      };
    }
    case PACKAGE_PROCESS: {
      return {
        ...apiData,
        packages: apiData?.package?.id,
      };
    }

    case SERVICE_PROCESS_DETAILS:
    case SERVICE_PROCESS_STEPS: {
      return {
        ...apiData,
        service: apiData?.service?.id,
      };
    }
    case SERVICE_TIMELINE: {
      return {
        ...apiData,
        table: JSON.parse(apiData?.table),
        service: apiData?.service?.id,
      };
    }

    case SERVICE_PROCESS_SUBTITLE: {
      return {
        ...apiData,
        title: apiData?.title?.id,
      };
    }

    case CONDITIONS_PAGE: {
      return {
        ...apiData,
        term: apiData?.term?.id,
      };
    }

    case TIME_LINE_HEADING:
    case SERVICE_BASED_FAQ: {
      return {
        ...apiData,
        service: apiData?.service?.id,
      };
    }

    case SERVICE_PAGE_FAQ: {
      return {
        ...apiData,
        serviceCategory: apiData?.serviceCategory?.id,
      };
    }

    case TIME_LINE_BODY: {
      return {
        ...apiData,
        timeLine: apiData?.timeLine?.id,
        date: apiData.date ? moment(apiData.date, 'YYYY-MM-DD') : '',
      };
    }

    case MANAGER_TECHNICIAN_ENTITY: {
      return {
        manager: apiData?.results?.id,
        technicians: apiData?.results?.technicians?.map(
          (technicians: { id: string }) => technicians.id
        ),
      };
    }

    case PHOTO_ORDER_APPLICATION: {
      // Create a function to organize photos by ID
      const organizePhotosById = (items: any) => {
        const organizedPhotos: any = {};

        items?.forEach((item: any) => {
          const { id, photo1, photo2, photo3, photo4 } = item;

          // Create an array for each unique ID
          if (!organizedPhotos[id]) {
            organizedPhotos[id] = [];
          }

          // Push photo URLs to the corresponding ID array
          organizedPhotos[id].push(photo1?.url, photo2?.url, photo3?.url, photo4?.url);
        });

        return organizedPhotos;
      };

      // Organize photos by ID
      // eslint-disable-next-line no-unused-vars
      const organizedPhotos = organizePhotosById(apiData?.items);

      return {
        ...apiData,
        userName: apiData?.user?.name,
        userEmail: apiData?.user?.email,
      };
    }

    case '/application/admin-order': {
      return {
        ...apiData,
        userName: apiData?.user?.name,
        userEmail: apiData?.user?.email,
        paymentStatus: apiData?.paymentDetails?.paymentStatus || '',
        plan: apiData?.pricingPlan?.title || '',
        pricingPlan: apiData?.pricingPlan,
      };
    }

    case CONTACT_INFO: {
      return {
        ...apiData,
        facebook: apiData?.socialMediaLinks?.facebook,
        facebookGroup: apiData?.socialMediaLinks?.facebookGroup,
        youtube: apiData?.socialMediaLinks?.youtube,
        instagram: apiData?.socialMediaLinks?.instagram,
        linkedIn: apiData?.socialMediaLinks?.linkedIn,
        whatsappChat: apiData?.socialMediaLinks?.whatsappChat,
        whatsappGroup: apiData?.socialMediaLinks?.whatsappGroup,
        x: apiData?.socialMediaLinks?.x,
        pinterest: apiData?.socialMediaLinks?.pinterest,
        tiktok: apiData?.socialMediaLinks?.tiktok,
        reddit: apiData?.socialMediaLinks?.reddit,
        email: apiData?.email,
      };
    }

    case REFFERAL_DETAILS: {
      return {
        ...apiData?.results,
        totalRefferals:
          apiData?.results?.refferalCompleted?.length +
          apiData?.results?.refferalIncompleted?.length,
        refferalCompleted: apiData?.results?.refferalCompleted,
        refferalIncompleted: apiData?.results?.refferalIncompleted,
      };
    }

    case ORDER_LIST_ENTITY: {
      return Object.keys(apiData).reduce((acc, key) => {
        if (key === 'store') {
          return {
            ...acc,
            store: apiData[key]?.name,
            storePhone: apiData[key]?.phone,
            line1: apiData[key]?.line1,
            line2: apiData[key]?.line2,
            state: apiData[key]?.state,
            city: apiData[key]?.city,
            latitude: apiData[key]?.latitude,
            longitude: apiData[key]?.longitude,
            landmark: apiData[key]?.landmark,
            storePincode: apiData[key]?.storePincode,
          };
        }

        if (key === 'address') {
          return {
            ...acc,
            addressType: apiData[key]?.addressType,
            customerLine1: apiData[key]?.line1,
            customerLine2: apiData[key]?.line2,
            streetName: apiData[key]?.streetName,
            customerLatitude: apiData[key]?.latitude,
            customerLongitude: apiData[key]?.longitude,
            customerLandmark: apiData[key]?.landmark,
            pincode: apiData[key]?.pincode,
          };
        }
        if (key === 'customer') {
          return {
            ...acc,
            id: apiData[key].id,
            name: apiData[key].name,
            email: apiData[key].email,
            phone: apiData[key].phone,
            referralCode: apiData[key].referralCode,
          };
        }

        if (key === 'slots') {
          const variants = apiData[key]?.reduce(
            (acc: any, slot: any) => [...acc, ...slot.variants],
            []
          );

          const addons = variants?.reduce(
            (acc: any, variant: any) => [
              ...acc,
              ...variant.addons.map((addon: any) => ({
                ...addon,
                variantSlug: variant.variantSlug,
              })),
            ],
            []
          );

          const bulkAddons = apiData[key].reduce((acc: any, currentValue: any) => {
            currentValue?.variants?.forEach((variant: any) => {
              if (variant.bulkAddon && Object.keys(variant.bulkAddon).length !== 0) {
                acc.push(variant.bulkAddon);
              }
            });
            return acc;
          }, []);

          return {
            ...acc,
            slots: apiData[key],
            addons,
            variants,
            bulkAddons,
          };
        }

        return { ...acc, [key]: apiData[key] };
      }, {});
    }
    case COUPONS_MANAGEMENT: {
      return {
        ...apiData,
        validity: apiData.validity ? moment(apiData.validity, 'YYYY-MM-DD') : '',
      };
    }

    case DOCUMITRA_PARTNERS: {
      // Handle legacy boolean status from backend if it hasn't been migrated/restarted yet
      let status = apiData.status;
      if (status === true) status = 'Active';
      else if (status === false) status = 'Inactive';
      // Convert 'Pending' to 'Active' for form display since 'Pending' is not a selectable option in CMS
      // 'Pending' status is automatically set on creation and changed to 'Active' on first login
      else if (status === 'Pending') status = 'Active';

      // Split contactNumber into countryCode and phone number
      // Format: "+91-7888154917" (new format with dash) or "+917888154917" (old format without dash)
      let countryCode = '';
      let phoneNumber = apiData.contactNumber || '';

      if (apiData.contactNumber && typeof apiData.contactNumber === 'string') {
        const contactNum = apiData.contactNumber.trim();

        // Check for new format with dash first: "+91-7888154917"
        if (contactNum.includes('-')) {
          const dashIndex = contactNum.indexOf('-');
          countryCode = contactNum.substring(0, dashIndex);
          let remaining = contactNum.substring(dashIndex + 1);
          // Take last 9 digits from phone number
          phoneNumber = remaining.length >= 10 ? remaining.slice(-10) : remaining;
          // Ensure country code has + prefix
          if (countryCode && !countryCode.startsWith('+')) {
            countryCode = '+' + countryCode;
          }
        } else if (contactNum.startsWith('+')) {
          // Old format without dash: "+917888154917" (backward compatibility)
          // Country codes can be 1-4 digits (e.g., +1, +91, +376, +1242)
          // Strategy: Try common lengths (2, 3, 1, 4) and take the one that leaves at least 9 digits
          // Then extract the last 9 digits as phone number
          const digitsOnly = contactNum.substring(1); // Remove the +
          // Try 2-digit codes first (most common: +91, +44, etc.), then 3, 1, 4
          const lengthsToTry = [2, 3, 1, 4];

          let found = false;
          for (const len of lengthsToTry) {
            if (digitsOnly.length > len && !found) {
              const potentialCode = '+' + digitsOnly.substring(0, len);
              const remaining = digitsOnly.substring(len);

              // If remaining has at least 9 digits, extract last 9
              if (remaining.length >= 9) {
                countryCode = potentialCode;
                phoneNumber = remaining.slice(-9); // Last 9 digits
                found = true;
              } else if (remaining.length >= 7 && !found) {
                // If less than 9 digits, use all remaining digits
                countryCode = potentialCode;
                phoneNumber = remaining;
                found = true;
              }
            }
          }

          // If no match found, try regex fallback
          if (!found) {
            const match = contactNum.match(/^\+(\d{1,3})(\d+)$/);
            if (match) {
              countryCode = '+' + match[1];
              const remaining = match[2];
              // Take last 9 digits
              phoneNumber = remaining.length >= 9 ? remaining.slice(-9) : remaining;
            }
          }
        }
      }

      return {
        ...apiData,
        status,
        countryCode, // This will be used by PhoneInput component
        contactNumber: phoneNumber, // This will be used by PhoneInput component
      };
    }
  }

  const entityNamesArray = entityName.split('/');
  const requiredEntityName = entityNamesArray[entityNamesArray.length - 1];

  switch (`/${requiredEntityName}`) {
    case PROCESSED_PHOTO_ENTITY: {
      return {
        ...apiData,
        documentType: apiData?.documentType,
        photo1: apiData?.photo1?.url,
        photo2: apiData?.photo2?.url,
        photo3: apiData?.photo3?.url,
        photo4: apiData?.photo4?.url,
        processedPhoto: apiData?.processedPhoto?.url,
        processedPhotoGrid: apiData?.processedPhotoGrid?.url,
      };
    }
    case '/documents': {
      return {
        ...apiData,
        image: getAssetUrl(apiData?.image),
      };
    }
    default:
      return apiData;
  }
};
